module.exports = __webpack_public_path__ + "img/symbol_9.a25fdbf3.png";